import { setUrlFromState } from "../helpers/setUrlFromState";
import { Data } from "../types/Data";
import { State } from "../types/State";
import { GroupLabel } from "./GroupLabel";
import { Store } from "./Store";

export class SurfaceInput {
  store: Store;
  data: Data;
  label: GroupLabel;

  constructor({
    store,
    data,
    label,
  }: {
    store: Store;
    data: Data;
    label: GroupLabel;
  }) {
    this.store = store;
    this.data = data;
    this.label = label;
    this.#initValue();
    this.#registerOnChange();
    this.#renderLabel();
  }

  #initValue() {
    (document.getElementById("surface-min")! as HTMLInputElement).value =
      this.store.getState()["surface-min"] || "0";
  }

  #registerOnChange() {
    const surfaceMin = document.getElementById(
      "surface-min"
    )! as HTMLInputElement;

    surfaceMin.addEventListener("input", () => {
      this.store.updateState("surface-min", surfaceMin.value);
      setUrlFromState(this.store.getState() as State);
      this.#renderLabel();
    });
  }

  #renderLabel() {
    this.label.refresh({
      state: this.store.getState(),
      data: this.data,
    });
  }
}
